import React from 'react';
import { Home, Building2, Store, Palette } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Building2 size={40} />,
      title: 'Office Interior Fit-outs',
      description: 'Complete office interior solutions including space planning, modern workstations, and functional design.',
      image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80'
    },
    {
      icon: <Home size={40} />,
      title: 'External Development',
      description: 'Comprehensive external development services for commercial and residential properties.',
      image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80'
    },
    {
      icon: <Palette size={40} />,
      title: 'Electrical Services',
      description: 'Professional electrical installation, wiring, and power distribution systems for all types of projects.',
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80'
    },
    {
      icon: <Store size={40} />,
      title: 'Low Voltage Services',
      description: 'Network cabling, telephone systems, data infrastructure, and structured cabling solutions.',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80'
    },
    {
      icon: <Home size={40} />,
      title: 'Access Control & Security',
      description: 'Advanced security systems, CCTV surveillance, access control, and integrated security solutions.',
      image: 'https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=800&q=80'
    },
    {
      icon: <Building2 size={40} />,
      title: 'Fire Alarm & Fire Fighting',
      description: 'Fire detection systems, fire alarm installation, and comprehensive fire safety solutions.',
      image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&q=80'
    },
    {
      icon: <Palette size={40} />,
      title: 'Graphics & Branding',
      description: 'Corporate branding, signage, wall graphics, and visual identity solutions for your space.',
      image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&q=80'
    },
    {
      icon: <Store size={40} />,
      title: 'Furniture Solutions',
      description: 'Custom and modular furniture, office furniture, and complete furnishing solutions.',
      image: 'https://images.unsplash.com/photo-1538688525198-9b88f6f53126?w=800&q=80'
    },
    {
      icon: <Building2 size={40} />,
      title: 'PMC Services',
      description: 'Project Management Consultancy services ensuring timely delivery and quality execution of projects.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80'
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-[#0a0a0c]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-[#FF8C42] text-sm tracking-[0.3em] uppercase mb-4">Our Services</p>
          <h2
            className="text-4xl md:text-5xl font-serif text-white mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            What We Offer
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Comprehensive interior design solutions and general solutions for residential and commercial spaces. Office interior fit-outs and MEP services (Mechanical, Electrical and Plumbing)
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-[#1a1a1c] rounded-sm overflow-hidden hover:shadow-2xl hover:shadow-[#FF8C42]/10 transition-all duration-500 hover:-translate-y-2"
            >
              {/* Background Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-[#0a0a0c]/80 to-transparent" />
              </div>

              {/* Content */}
              <div className="relative p-8">
                <div className="text-[#FF8C42] mb-4 transition-transform duration-300 group-hover:scale-110">
                  {service.icon}
                </div>
                <h3 className="text-xl font-serif text-white mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {service.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">{service.description}</p>
              </div>

              {/* Hover Border Effect */}
              <div className="absolute inset-0 border border-[#FF8C42]/0 group-hover:border-[#FF8C42]/30 transition-all duration-500 pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;